import React from "react";

export const CryptoDailyIcon = ( props: React.SVGProps<SVGSVGElement> ) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        {...props}
    >
        <g clipPath="url(#clip0_17454_52629)">
            <path
                d="M8.00016 14.6654C11.6821 14.6654 14.6668 11.6806 14.6668 7.9987C14.6668 4.3168 11.6821 1.33203 8.00016 1.33203C4.31826 1.33203 1.3335 4.3168 1.3335 7.9987C1.3335 11.6806 4.31826 14.6654 8.00016 14.6654Z"
                stroke="#77808D"
                strokeWidth="1.5"
                strokeLinejoin="round"
            />
            <path
                d="M8.00284 4L8.00244 8.00293L10.8289 10.8294"
                stroke="#77808D"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </g>
        <defs>
            <clipPath id="clip0_17454_52629">
                <rect width="16" height="16" fill="white" />
            </clipPath>
        </defs>
    </svg>
);
